export default "__VITE_ASSET__BDUntPme__"